import React, { useEffect, useRef } from "react";
import "./header.css";

export const Header = ({ data, profileImage }) => {
  const heroRef = useRef(null);
  const profileName = data?.title || "Angelica Narvaez Espinosa";
  const heroImage = profileImage || "";
  const safeImage = heroImage ? encodeURI(heroImage) : "";
  const heroBg = `${process.env.PUBLIC_URL}/img/intro-bg.jpg`;

  useEffect(() => {
    const hero = heroRef.current;
    if (!hero) return undefined;

    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const finePointer = window.matchMedia("(pointer: fine)").matches;
    const target = { x: 0, y: 0 };
    const current = { x: 0, y: 0 };
    let rafId = 0;

    const setCenterGlow = () => {
      const rect = hero.getBoundingClientRect();
      hero.style.setProperty("--cx", `${rect.width * 0.66}px`);
      hero.style.setProperty("--cy", `${rect.height * 0.52}px`);
    };

    const onScroll = () => {
      const rect = hero.getBoundingClientRect();
      const viewport = window.innerHeight || 1;
      const centerDelta = viewport * 0.5 - (rect.top + rect.height * 0.5);
      const normalized = Math.max(-1, Math.min(1, centerDelta / viewport));
      hero.style.setProperty("--sy", normalized.toFixed(4));
    };

    const animate = () => {
      current.x += (target.x - current.x) * 0.14;
      current.y += (target.y - current.y) * 0.14;
      hero.style.setProperty("--mx", current.x.toFixed(4));
      hero.style.setProperty("--my", current.y.toFixed(4));
      rafId = window.requestAnimationFrame(animate);
    };

    const onMouseMove = (event) => {
      const rect = hero.getBoundingClientRect();
      const px = event.clientX - rect.left;
      const py = event.clientY - rect.top;
      const nx = ((px / rect.width) - 0.5) * 2;
      const ny = ((py / rect.height) - 0.5) * 2;

      target.x = Math.max(-1, Math.min(1, nx));
      target.y = Math.max(-1, Math.min(1, ny));
      hero.style.setProperty("--cx", `${px}px`);
      hero.style.setProperty("--cy", `${py}px`);
    };

    const onMouseLeave = () => {
      target.x = 0;
      target.y = 0;
      setCenterGlow();
    };

    setCenterGlow();
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", setCenterGlow);

    if (!reduceMotion && finePointer) {
      hero.addEventListener("mousemove", onMouseMove);
      hero.addEventListener("mouseleave", onMouseLeave);
      rafId = window.requestAnimationFrame(animate);
    }

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", setCenterGlow);
      hero.removeEventListener("mousemove", onMouseMove);
      hero.removeEventListener("mouseleave", onMouseLeave);
      if (rafId) window.cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <header className="ph-hero" id="header" ref={heroRef}>
      <div className="ph-hero__bg" style={{ backgroundImage: `url("${heroBg}")` }} aria-hidden="true" />
      <div className="ph-hero__scrim" aria-hidden="true" />
      <div className="ph-hero__cursor-light" aria-hidden="true" />

      <div className="ph-hero__split">
        <section className="ph-hero__pane ph-hero__pane--left">
          <p className="ph-hero__eyebrow">Atencion psicologica online y presencial</p>

          <h1 className="ph-hero__title">Acompa&ntilde;amiento psicol&oacute;gico online</h1>

          <p className="ph-hero__lead">
            En un espacio confidencial, orientado a la reflexi&oacute;n, el autoconocimiento y
            la toma consciente de decisiones personales.
          </p>

          <p className="ph-hero__body">
            Agenda tu consulta y recibe una orientacion clara, confidencial y centrada en tus
            objetivos.
          </p>

          <div className="ph-hero__actions">
            <a href="https://wa.me/+573206646473" className="ph-hero__btn ph-hero__btn--primary">
              Agendar por WhatsApp
            </a>
            <a href="#features" className="ph-hero__btn ph-hero__btn--secondary">
              Ver servicios
            </a>
          </div>

          <p className="ph-hero__note">
            Haz clic en el boton y cuentame brevemente tu caso para proponerte el mejor proceso.
          </p>
        </section>

        <aside className="ph-hero__pane ph-hero__pane--right" aria-hidden="true" />

        {safeImage ? (
          <figure className="ph-hero__bridge">
            <img src={safeImage} alt={profileName} className="ph-hero__portrait" />
          </figure>
        ) : null}
      </div>
    </header>
  );
};

